
import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { tableClasses } from '../constants';
import { Paper } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';

export default function SensorTable(props) {
  const { 
    currDarkThemeClass, 
    animationClass, 
    tableTitles = [],
    tableEntries = [],
    page = 0,
    rowsPerPage = 10,
    totalCount = 0,
    onPageChange = () => {},
    onRowsPerPageChange = () => {},
  } = props;

    const displayTableContainerProps = {
        className: `${tableClasses?.displayTable?.tableContainer} ${currDarkThemeClass} ${animationClass}`,
        component: Paper,
        variant: 'none',
    };

    const displayTableProps = {
        className: `${tableClasses?.displayTable?.table} ${currDarkThemeClass}`,
        stickyHeader: true,
    };

    const displayTableTitleCellProps = {
        className: `${tableClasses?.displayTable?.titleCell} ${currDarkThemeClass}`,
    };

    const displayTableRowProps = {
        className: `${tableClasses?.displayTable?.tableRow} ${currDarkThemeClass}`,
    };

    const displayTableEntryCellProps = {
        className: `${tableClasses?.displayTable?.entryCell} ${currDarkThemeClass}`,
    };

    const noEntityProps = {
        className: `${tableClasses?.displayTable?.noEntityTableCell} ${currDarkThemeClass}`,
        colSpan: '100%',
    };
    
    const paginatedEntries = tableEntries.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    
    return (
      <TableContainer {...displayTableContainerProps} sx={{ height: '100%', overflow: 'auto', }}>
            <Table {...displayTableProps}>
                <TableHead>
                    <TableRow >
                        {tableTitles.map((title, i) => (
                            <TableCell
                                key={title?.key}
                                align={title.align ?? 'left'}
                                style={{ minWidth: title.minWidth }}
                                {...displayTableTitleCellProps}
                            >
                                {title.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                {tableEntries.length === 0 ? (
                    <TableRow tabIndex={-1}>
                    <TableCell {...noEntityProps}>No Sensor Added</TableCell>
                    </TableRow>
                    ) : (
                    paginatedEntries.map((entry, i) => (
                    <TableRow tabIndex={-1} key={`row-${i}`} {...displayTableRowProps}>
                        {tableTitles.map((title) => {
                        const value = entry[title.key];
                        return (
                            <TableCell
                            key={title.key}
                            align={title.align ?? "left"}
                            {...displayTableEntryCellProps}
                            >
                            {value}
                            </TableCell>
                        );
                        })}
                    </TableRow>
                    ))
                )}
                </TableBody>
            </Table>
            <TablePagination
                component="div"
                count={totalCount}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={(event, newPage) => onPageChange(newPage)}
                onRowsPerPageChange={(event) =>
                    onRowsPerPageChange(parseInt(event.target.value, 10))
                }
                rowsPerPageOptions={[5, 10, 15, 25]}
                sx={{
                    backgroundColor: currDarkThemeClass ? '#1a1b19' : '#F7FAEA',
                    color: currDarkThemeClass ? '#ffffff' : '#000000',

                    '& .MuiSvgIcon-root': {
                    color: currDarkThemeClass ? '#ffffff' : '#000000',
                    },

                    /* disabled arrow style */
                    '& .Mui-disabled': {
                    opacity: 0.3,
                    color: '#888',
                    cursor: 'not-allowed'
                    }
                }}
            />
        </TableContainer>
    )
}